module.exports = __webpack_public_path__ + "static/img/KW.240dcfca.svg";